import { API } from '~/config';

// API.URL uses http(s):// — replace scheme for WebSocket.
export const deriveWsUrl = (path: string): string => `${API.URL.replace(/^http/, 'ws')}${path}`;
